import { GENERAL, GENERAL_OPTION_SELECT, SECONDARY_NAV_NEXT_CLICK } from '../constants';

export interface GeneralReducerState {
    isComplete: boolean;
    must: number;
    does: number;
    commitment: number;
}

interface Payload {
    option: number;
    id: string;
    navId: string;
}

interface Action {
    type: string;
    payload: Payload;
}

const initialState = {
    isComplete: false,
    must: 5,
    does: 5,
    commitment: 5,
};

function upateOptionState(state: GeneralReducerState, payload: Payload) {
    state[payload.id] = payload.option;

    return {
        ...state
    };
}

function isActiveSection(navId: string) {
    return navId === GENERAL;
}

const generalReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case SECONDARY_NAV_NEXT_CLICK:
            if (isActiveSection(action.payload.navId)) {
                return {
                    ...state,
                    isComplete: true
                };
            }

            return {
                ...state
            };
        case GENERAL_OPTION_SELECT:
            const newState = upateOptionState(state, action.payload);

            return {
                ...state,
                ...newState
            };
        default:
            return {
                ...state
            };
    }
};

export default generalReducer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/reducers/generalReducer.ts